// eslint-disable-next-line no-use-before-define
import React, { useEffect } from "react";
import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { OrigoAuthenticator } from "@oriola-origo/origo-app-shell";
import { StylesProvider } from "@material-ui/core";
import { Layout, RestService } from "./components/generic";
import { ProtectedRoute, Permission } from "./components/auth";
import {
  userSignIn,
  fetchUserDataFromOrigo,
  fetchCustomers,
  setTokenData,
  setSelectedCustomer,
  userSignOut,
} from "./redux/reducers";
import { Paths } from "./utils/navigation/navigation";
import ProductManagement from "./components/productManagement/productManagement";
import Profile from "./components/profile/profile";
import Faq from "./components/faq/faq";
import ContactUs from "./components/contactUs/contactUs";
import NotFound from "./components/404/404";

function App() {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const user = useSelector(state => state.user);
  const { userData } = user;
  const { search } = useLocation();

  if (user.tokenData && user.sessionId) {
    RestService.init(user, res => dispatch(setTokenData(res)));
  }

  // Customer data is required for app to work correctly
  const { customers, selectedCustomerId } = useSelector(
    state => state.customer
  );

  useEffect(() => {
    const organizationId = new URLSearchParams(search).get("organizationId");
    // If query params have organizationId store it
    if (organizationId && organizationId !== selectedCustomerId) {
      dispatch(setSelectedCustomer(organizationId));
      // Use first customer as fallback
    } else if (!selectedCustomerId && customers.length > 0) {
      dispatch(setSelectedCustomer(customers[0].customerId));
    }
  }, [search, selectedCustomerId, customers, dispatch]);

  const initialize = signInData => {
    dispatch(userSignIn(signInData));
    const { userId, organizationIds } = signInData.userData;

    dispatch(fetchUserDataFromOrigo(userId)).then(origoUserData => {
      if (origoUserData && origoUserData.language) {
        i18n.changeLanguage(origoUserData.language);
      }
    });

    dispatch(fetchCustomers(organizationIds));
  };

  const renderApp = () => (
    <Layout>
      <Routes>
        <Route
          path={Paths.ProductManagement}
          element={
            <ProtectedRoute
              user={userData}
              failComponent={<NotFound />}
              requiredPermission={Permission.AVAILABILITY}
            >
              <ProductManagement />
            </ProtectedRoute>
          }
        />
        <Route path={Paths.Profile} element={<Profile />} />
        <Route path={Paths.FAQ} element={<Faq />} />
        <Route path={Paths.ContactUs} element={<ContactUs />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
  return (
    <OrigoAuthenticator
      isSignedIn={user.signedIn}
      onSignedIn={signInData => initialize(signInData)}
      onSignedOut={() => {
        // clear
        dispatch(userSignOut());
      }}
    >
      <StylesProvider injectFirst>{renderApp()}</StylesProvider>
    </OrigoAuthenticator>
  );
}

export default App;
